module.exports = __webpack_public_path__ + "img/dexter_with_key_ring.509e5b5d.jpg";